import React, { useState, useEffect} from "react";
import { TabTablePanel } from "../TabTablePanel/TabTablePanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import SwipeableViews from "react-swipeable-views";
import "./style.css";

export const DynamicTabs = (props) => {
  const [tabId, setTabId] = useState(props.tabPointer ?? 0);
  const [isImperial] = useState(props.isImperial);
  let whichTable = props.whichTable;

  const {
    numberOfTabs,
    isu90tabCount,
    flat463LtabCount,
    c463LtabCount,
    nfevtabCount,
    pallet80x120tabCount,
    pallet100x120tabCount,
    totalWeights,
    rows: filteredRows, // <-- parent filtered rows
  } = props;

  // Row parser function using filtered rows
  function rowparser(containerID, containertype) {
    return (filteredRows ?? []).filter(
      (row) => row.palletid === containerID && row.storagetype === containertype
    );
  }

  // Build tabs and tab panels dynamically
  const tabs = [];
  const tabsContent = [];
  let tabIndex = 0;

  // Helper function to loop through pallets
  const addTabsForType = (count, labelPrefix, containerType) => {
    for (let i = 1; i <= count; i++) {
      tabIndex++;
      tabs.push(<Tab label={`${labelPrefix} ${i}`} key={`${labelPrefix}-${i}`} />);
      const newRows = rowparser(i, containerType);
      tabsContent.push(
        <TabTablePanel
          key={`panel-${labelPrefix}-${i}`}
          tabid={tabIndex}
          index={tabIndex}
          value={tabIndex}
          whichTable={whichTable}
          rows={newRows}
          palletid={i}
          storageContainerType=""
          totalWeight={totalWeights?.[tabIndex - 1]}
          containerType={containerType}
        />
      );
    }
  };

  addTabsForType(isu90tabCount, "ISU-90", "ISU-90");
  addTabsForType(flat463LtabCount, "463L", "463L");
  addTabsForType(c463LtabCount, "C463L", "C463L");
  addTabsForType(nfevtabCount, "NFEV", "NFEV");
  addTabsForType(pallet80x120tabCount, "80x120", "80x120");
  addTabsForType(pallet100x120tabCount, "100x120", "100x120");

  const handleChange = (event, newValue) => setTabId(newValue);
  const handleChangeIndex = (index) => setTabId(index);

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Tabs
        value={tabId}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={false}
        TabIndicatorProps={{ style: { background: "#E3EFFB" } }}
      >
        {tabs}
      </Tabs>

      <SwipeableViews index={tabId} onChangeIndex={handleChangeIndex} style={{}}>
        {tabsContent}
      </SwipeableViews>
    </Box>
  );
};

export default DynamicTabs;
